import tinymce from 'tinymce/tinymce'

tinymce.PluginManager.add('pageBrowser', function (editor, url) {
  const userText = 'Internen Link einfügen/bearbeiten'
  let bookmark

  const openPageBrowserInCMS = function () {
    const selection = window.getSelection()
    const node = selection.focusNode.nodeType === Node.TEXT_NODE ? selection.focusNode.parentNode : selection.focusNode
    const payload = {
      selection: {
        text: window.getSelection().toString(),
        resource: node.dataset ? node.dataset.resource : null,
        href: node.getAttribute('href')
      }
    }
    const message = { event: 'cms:openPageBrowser', payload }
    // eslint-disable-next-line no-console
    console.info('Sending message to CMS with', message)
    window.parent.postMessage(message, '*')

    // CMS results bluring the editor and cleaning its content from bookmarks
    // save important info needed to insert the link in the right place
    bookmark = {
      // saves the selection position
      editorBookmark: editor.selection.getBookmark(),
      // saves the content of the editor to prevent it from changing
      EditorInnerHTML: editor.getContentAreaContainer().innerHTML
    }
  }

  const receiveMessage = function (event) {
    // there must be a saved bookmark for this editor first
    if (event.data.event === 'cms:setLink' && bookmark) {
      const { resource } = event.data.payload
      // Making sure active editor is not changed
      if (editor.id !== tinymce.activeEditor.id) {
        tinymce.setActive(editor)
      }
      if (resource) {
        // restore the editors content the way it was when the bookmark was taken
        editor.setContent(bookmark.EditorInnerHTML, { format: 'html' })
        // restore selection to the taken bookmark
        editor.selection.moveToBookmark(bookmark.editorBookmark)
        // insert new link
        editor.insertContent(`<a class="link" href="${resource.url}" data-resource="${resource.id}">${editor.selection.getContent()}</a>`)
        // reset bookmark
        bookmark = undefined
      }
    }
  }

  // Add a button that opens a window
  editor.ui.registry.addButton('pageBrowser', {
    icon: 'browse',
    tooltip: userText,
    onAction () {
      openPageBrowserInCMS()
    }
  })

  // Adds a menu item, which can then be included in any menu via the menu/menubar configuration
  editor.ui.registry.addMenuItem('pageBrowser', {
    text: userText,
    onAction () {
      openPageBrowserInCMS()
    }
  })

  window.addEventListener(
    'message',
    receiveMessage,
    false
  )

  return {
    getMetadata () {
      return {
        name: 'Page Browser Plugin'
      }
    }
  }
})
